import { render, staticRenderFns } from "./Ticket.vue?vue&type=template&id=cca98634&"
import script from "./Ticket.vue?vue&type=script&lang=ts&"
export * from "./Ticket.vue?vue&type=script&lang=ts&"
import style0 from "@/style/components/tickets/ticket.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports